import React, { forwardRef } from 'react'

const DangerousHtml = forwardRef(({ tag: Tag, children: __html, dangerouslySetInnerHTML, ...props }, ref) => (
    <Tag
        {...props}
        dangerouslySetInnerHTML={{
            __html,
        }}
        ref={ref}
    />
))

export default DangerousHtml
